import HomeWidget from './HomeWidget';

export default HomeWidget;